/*
 * Copyright (c) 2021-2024 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
 * LicenseRef-NvidiaProprietary
 *
 * NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
 * property and proprietary rights in and to this material, related
 * documentation and any modifications thereto. Any use, reproduction,
 * disclosure or distribution of this material and related documentation
 * without an express license agreement from NVIDIA CORPORATION or
 * its affiliates is strictly prohibited
 */

import io from 'socket.io-client';

const socketIOClient = path => new Promise((resolve, reject) => {
    const socket = io(`${window.airschipp.websocket}${path}`, {
        path: window.airschipp.websocketPath,
    });
    socket.on('connect', () => resolve(socket));
    socket.on('connect_error', err => reject(err));
});
export default socketIOClient;
